import type { ObjectType } from './types'

export const objectHasNonNullableProp = (object: ObjectType): boolean => {
  return Object.values(object).some(x => !!x)
}
